import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";
import { settleOrder } from "./cartSlice";

/**
 * Get All Tables
 */
export const getAllTables = createAsyncThunk(
  "table/getAllTables",
  async (obj, { rejectWithValue }) => {
    try {
      const { storeId } = obj;
      const res = await mainApi.get(
        `/v1/pos/orders/tables?store_id=${storeId}&offset=0&limit=10`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
/**
 * Fetch Active Table Count
 */
export const fetchActiveTableCount = createAsyncThunk(
  "table/fetchActiveCount",
  async (storeId, { rejectWithValue }) => {
    try {
      const res = await mainApi.get(
        `v1/pos/orders/active-count?store_id=${storeId}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Slice
const orderSlice = createSlice({
  name: "table",
  initialState: {
    tableDines: [],
    activeCount: 0,
    activeKotCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    calculateBusyTableCount: (state) => {
      const allTables = state.tableDines.flatMap((area) => area.tables);
      const count = allTables.filter(
        (table) => table?.order?.kots && Object.keys(table.order.kots).length > 0
      ).length;

      state.activeCount = count;
    },
    incrementActiveCount: (state) => {
      state.activeCount += 1;
    },
    clearOrderState: (state) => {
      state.tableDines = [];
      state.activeCount = 0;
      state.activeKotCount = 0;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get tables
      .addCase(getAllTables.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTables.fulfilled, (state, action) => {
        state.loading = false;
        state.tableDines = action.payload;
      })
      .addCase(getAllTables.rejected, (state, action) => {
        state.loading = false;
      })

      // Fetch Active Table Count
      .addCase(fetchActiveTableCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchActiveTableCount.fulfilled, (state, action) => {
        state.loading = false;
        state.activeCount = action.payload?.active_order_count || 0;
        state.activeKotCount = action.payload?.active_kot_count || 0;
      })
      .addCase(fetchActiveTableCount.rejected, (state, action) => {
        state.loading = false;
      })

      // Settle Order
      .addCase(settleOrder.fulfilled, (state, action) => {
        const settledTableId = action.payload?.dine_area_table_uid;
        if (!settledTableId) return;

        state.tableDines = state.tableDines.map((area) => ({
          ...area,
          tables: area.tables.map((table) =>
            table.dine_area_table_uid === settledTableId
              ? {
                  ...table,
                  order: {},
                  order_dine_table_id: null,
                  order_dine_table_uid: null,
                  order_dine_table_status_id: 0,
                }
              : table
          ),
        }));
      });
  },
});

export const {
  calculateBusyTableCount,
  clearOrderState,
  incrementActiveCount,
} = orderSlice.actions;
export default orderSlice.reducer;
